/**
 * App Providers Wrapper
 * ======================
 * Mounts the app-only context providers that are needed inside the
 * authenticated application shell (MainLayout). These are never loaded on
 * public pages — MainLayout is lazy-loaded and only renders for /app/* routes,
 * so these providers (and their dependencies) stay out of the public bundle.
 *
 * PublicProviders (Portal, Auth, DemoTrial, Toast) are already mounted at the
 * App.js level and are available here via context.
 */
import React from 'react';
import { PermissionProvider } from '../context/PermissionContext';
import { SubscriptionProvider } from '../context/SubscriptionContext';
import { OrganizationProvider } from '../context/OrganizationContext';
import { CurrencyProvider } from '../context/CurrencyContext';
import { TimezoneProvider } from '../context/TimezoneContext';
import { ReportTemplateProvider } from '../context/ReportTemplateContext';
import { DataCacheProvider } from '../context/DataCacheContext';
import { SearchProvider } from '../context/SearchContext';
import { ConfirmProvider } from './common/ConfirmDialog';
import { ClinicalParametersProvider } from '../context/ClinicalParametersContext';

const AppProviders = ({ children }) => {
  return (
    <PermissionProvider>
      <SubscriptionProvider>
        <OrganizationProvider>
          <CurrencyProvider>
            <TimezoneProvider>
              <ReportTemplateProvider>
                <DataCacheProvider>
                  <SearchProvider>
                    <ConfirmProvider>
                      <ClinicalParametersProvider>
                        {children}
                      </ClinicalParametersProvider>
                    </ConfirmProvider>
                  </SearchProvider>
                </DataCacheProvider>
              </ReportTemplateProvider>
            </TimezoneProvider>
          </CurrencyProvider>
        </OrganizationProvider>
      </SubscriptionProvider>
    </PermissionProvider>
  );
};

export default AppProviders;
